import { render, staticRenderFns } from "./FeedCoins.vue?vue&type=template&id=914174e2&scoped=true&"
import script from "./FeedCoins.vue?vue&type=script&lang=ts&"
export * from "./FeedCoins.vue?vue&type=script&lang=ts&"
import style0 from "./FeedCoins.scss?vue&type=style&index=0&id=914174e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914174e2",
  null
  
)

export default component.exports